import { API_BASE_URL } from '../constants';
import { isMarketingHost } from '../utils/siteHost';

function contactApiBaseUrl(): string {
  if (typeof window !== 'undefined' && isMarketingHost()) {
    return `${window.location.origin}/api`;
  }
  return API_BASE_URL;
}

export type ContactTopic = 'demo' | 'general' | 'support';

export interface ContactInquiryPayload {
  name: string;
  email: string;
  organization?: string;
  subject?: string;
  message: string;
  topic?: ContactTopic;
  website?: string;
}

export async function submitContactInquiry(
  payload: ContactInquiryPayload
): Promise<void> {
  const response = await fetch(`${contactApiBaseUrl()}/marketing/contact`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let detail = 'Unable to send your message. Please try again.';
    try {
      const data = (await response.json()) as { detail?: string };
      if (typeof data.detail === 'string') {
        detail = data.detail;
      }
    } catch {
      /* ignore */
    }
    throw new Error(detail);
  }
}
